<template>
  <header-layout>
    <template #right>
      <template v-if="!$breakpoint.smAndDown">
        <div>
          <c-button
            :style="{ marginRight: '.6rem', fontWeight: '600' }"
            :to="{ name: $routes.pricing }"
          >
            Pricing
          </c-button>
        </div>
        <div>
          <c-button
            :style="{ marginRight: '.6rem', fontWeight: '600' }"
            :to="{ name: $routes.home }"
          >
            Log in
          </c-button>
        </div>
        <div>
          <c-button
            color="primary"
            :style="{ fontWeight: '600' }"
            :to="{ name: $routes.register }"
          >
            Sign up
          </c-button>
        </div>
      </template>
      <c-dropdown v-else>
        <c-button
          icon="hamburger"
          fab
        />
        <template #content>
          <c-card
            contains-list
            :style="{ width: 'calc(100vw - 16px)' }"
          >
            <router-link :to="{ name: $routes.pricing }">
              <c-card-item title="Pricing" />
            </router-link>
            <router-link :to="{ name: $routes.home }">
              <c-card-item title="Login" />
            </router-link>
            <router-link :to="{ name: $routes.register }">
              <c-card-item title="Sign up" />
            </router-link>
          </c-card>
        </template>
      </c-dropdown>
    </template>
  </header-layout>
</template>

<script>
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CCardItem from 'shared/components/CCardItem.vue';
import CDropdown from 'shared/components/CDropdown.vue';
import HeaderLayout from 'shared/components/HeaderLayout.vue';

export default {
  name: 'WebsiteHeader',
  components: { CButton, HeaderLayout, CCard, CCardItem, CDropdown },
  data() {
    return { open: false };
  },
};
</script>

<style scoped lang="scss" type="text/scss">

</style>
